import { useTranslation } from 'react-i18next'
import styles from './StatementReportTable.module.scss'
function StatementReportTable({ data }) {
  const { t } = useTranslation('common')
  return (
    <div>
      <table className={styles.table__wrapper}>
        <thead className={styles.table__head}>
          <tr className={styles.table__row}>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.applicant')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.addressee')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.type')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.title')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.status')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('statements.list.submission_date')}</span>
            </th>
          </tr>
        </thead>

        <tbody className={styles.table__body}>
          {data?.map((item, index) => {
            return (
              <tr key={index} className={styles.table__row}>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>{item.employee}</span>
                </td>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>
                    {item?.employee?.first_name} {item.addressee}
                  </span>
                </td>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>{item.type_doc}</span>
                </td>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>{item.type}</span>
                </td>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>{item.status}</span>
                </td>
                <td className={styles.table__item}>
                  <span className={styles.table__title}>
                    {item.date_zayavki}
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default StatementReportTable
